export const BG_COLOR = '#EFF6FF'
